<template>
  <page-view :title="false">
    <a-card :bordered="false">
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="8" :sm="24">
              <a-form-item label="流水号"
                ><a-input v-model="queryParam.verifyNo" placeholder="流水号"
              /></a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="手机|邮箱"
                ><a-input
                  v-model="queryParam.linkMobileEmail"
                  placeholder="手机|邮箱"
              /></a-form-item>
            </a-col>
            <template v-if="advanced">
              <a-col :md="8" :sm="24">
                <a-form-item label="类型">
                  <a-select v-model="queryParam.linkType" placeholder="请选择">
                    <a-select-option value="SMS">短信</a-select-option>
                    <a-select-option value="EMAIL">邮箱</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
            </template>
            <a-col :md="(!advanced && 8) || 24" :sm="24">
              <span
                class="table-page-search-submitButtons"
                :style="
                  (advanced && { float: 'right', overflow: 'hidden' }) || {}
                "
              >
                <a-button type="primary" @click="$refs.table.refresh(true)"
                  >查询</a-button
                >
                <a-button
                  style="margin-left: 8px"
                  @click="() => (queryParam = {})"
                  >重置</a-button
                >
                <a @click="toggleAdvanced" style="margin-left: 8px">
                  {{ advanced ? "收起" : "展开" }}
                  <a-icon :type="advanced ? 'up' : 'down'" />
                </a>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>

      <s-table
        ref="table"
        size="default"
        rowKey="verifyNo"
        :columns="columns"
        :data="loadData"
        showPagination="auto"
      >
        <span slot="tagItem" slot-scope="text, record">
          <template>
            {{ text }}
            <a-tag
              class="render-tag"
              :color="
                record.sta == 'R'
                  ? '#108ee9'
                  : record.sta == 'I'
                  ? 'red'
                  : record.sta == 'P'
                  ? '#FFB800'
                  : 'grey'
              "
              >{{
                record.sta == "R"
                  ? "未使用"
                  : record.sta == "I"
                  ? "已使用"
                  : record.sta == "P"
                  ? "已过期"
                  : "已停用"
              }}</a-tag
            >
          </template>
        </span>
        <span slot="action" slot-scope="text, record">
          <template>
            <a-popconfirm
              title="确认停用?"
              @confirm="action(record, 'X')"
              v-if="record.sta == 'R'"
              v-hasAnyPermission="`edmverify:stop`"
              okText="确认"
              cancelText="取消"
              ><a class="a-action">停用</a></a-popconfirm
            >
          </template>
        </span>
      </s-table>
    </a-card>
  </page-view>
</template>

<script>
import moment from "moment";
import { STable } from "@/components";
import { PageView } from "@/layouts";

export default {
  name: "EdmVerifyList",
  components: {
    STable,
    PageView
  },
  data() {
    return {
      // 高级搜索 展开/关闭
      advanced: false,
      // 查询参数
      queryParam: {},
      // 表头
      columns: [
        {
          title: "流水号",
          dataIndex: "verifyNo"
        },
        {
          title: "手机或邮箱",
          dataIndex: "linkMobileEmail"
        },
        {
          title: "验证码",
          dataIndex: "verifyCode",
          scopedSlots: { customRender: "tagItem" }
        },
        {
          title: "过期时间点",
          dataIndex: "verifyTime"
        },
        {
          title: "操作人",
          dataIndex: "modifyUser"
        },
        {
          title: "更新时间",
          dataIndex: "modifyDatetime"
        },
        {
          title: "操作",
          dataIndex: "action",
          scopedSlots: { customRender: "action" }
        }
      ],
      // 加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        return this.$http.roomBksApi
          .pageEdmVerify(Object.assign(parameter, this.queryParam))
          .then(res => {
            return res.resultObject;
          });
      }
    };
  },
  created() {},
  methods: {
    action(record, type) {
      this.$http.roomBksApi
        .modifyEdmVerifyStaByVerifyNo({ verifyNo: record.verifyNo, sta: type })
        .then(res => {
          if (res.result == 0) {
            this.$refs.table.refresh(true);
            this.$message.success(res.msg);
          }
        });
    },
    /**
     * 展开/收起查询条件
     */
    toggleAdvanced() {
      this.advanced = !this.advanced;
    }
  }
};
</script>
